export const isRepertoireCreateAvailable = () =>
  process.env.REACT_APP_NODE_ENV === 'local' ||
  process.env.REACT_APP_NODE_ENV === 'dev' ||
  import.meta.env.DEV ||
  (typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'));
